import { As } from '@chakra-ui/react';

import { HeadingWithEmphasis } from '~/components/heading-with-emphasis';

// The main title above the plan cards.
export function PlanCardSectionTitle(props: { title: string; as: As }) {
  return (
    <HeadingWithEmphasis
      text={props.title}
      emphasisProps={{
        fontWeight: '500',
        color: 'blue.500',
      }}
      headingProps={{
        color: 'blue.800',
        as: props.as,
        size: {
          base: 'marketing-2xl',
          md: 'marketing-4xl',
        },
        textAlign: 'center',
        whiteSpace: {
          xl: 'pre-wrap',
        },
      }}
    />
  );
}
